import { render, staticRenderFns } from "./Denegado.vue?vue&type=template&id=7993a150&scoped=true"
import script from "./Denegado.vue?vue&type=script&lang=js"
export * from "./Denegado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7993a150",
  null
  
)

export default component.exports